import PropTypes from "prop-types";
import Button from "solar/components/Button";
import Text from "components/shared/stays/Text";
import Message from "components/shared/stays/Message";
import styles from "components/stay/AvailabilityFooter.module.scss";

export default function AvailabilityFooter({
  tripID,
  tripName,
  guideID,
  guidePrimaryEmployeeFirstName,
  guidePrimaryEmployeeImageUrl,
  responseTime = null,
  closestTrips = [],
}) {
  return (
    <div className={styles.component}>
      <Text>
        {
          "For dates and accommodations not listed, or if you want to book further out "
        }
        <Message
          tripID={tripID}
          tripName={tripName}
          guideID={guideID}
          guidePrimaryEmployeeFirstName={guidePrimaryEmployeeFirstName}
          guidePrimaryEmployeeImageUrl={guidePrimaryEmployeeImageUrl}
          closestTrips={closestTrips}
          responseTime={responseTime}
          key={tripID}
        >
          <Button link>{`message ${guidePrimaryEmployeeFirstName}.`}</Button>
        </Message>
      </Text>
    </div>
  );
}

AvailabilityFooter.propTypes = {
  tripID: PropTypes.string.isRequired,
  tripName: PropTypes.string.isRequired,
  guideID: PropTypes.string.isRequired,
  guidePrimaryEmployeeFirstName: PropTypes.string.isRequired,
  guidePrimaryEmployeeImageUrl: PropTypes.string.isRequired,
  responseTime: PropTypes.number,
  closestTrips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      country: PropTypes.string,
      lowest_price: PropTypes.node,
      product_type: PropTypes.string,
      trip_type_description: PropTypes.string,
      is_featured: PropTypes.bool,
      image_url: PropTypes.string,
      distance: PropTypes.number,
    })
  ),
};
